/** @jsxImportSource @emotion/react */
import PropTypes from 'prop-types';
import { Fragment, useEffect, useReducer, useRef } from 'react';

import { EMPTY_STRING } from '../../const';
import optionsReducer from '../../reducers/multiOptions';
import filterMenuStyle from '../FiltersMenu/styles';
import { ToolTipIcon } from '../Icons';
import TooltipInfo from '../TooltipInfo';
import useStyles from './styles';

const dayOptions = [
  {
    id: 1,
    text: 'Monday',
    value: '1',
  },
  {
    id: 2,
    text: 'Tuesday',
    value: '2',
  },
  {
    id: 3,
    text: 'Wednesday',
    value: '3',
  },
  {
    id: 4,
    text: 'Thursday',
    value: '4',
  },
  {
    id: 5,
    text: 'Friday',
    value: '5',
  },
  {
    id: 6,
    text: 'Saturday',
    value: '6',
  },
  {
    id: 7,
    text: 'Sunday',
    value: '7',
  },
];

const FilterByDays = ({
  onSave,
  currentValue,
  onErrorChange,
  filterShowHide,
  quickSearch,
}) => {
  const styles = useStyles();
  const filterMenuStyles = filterMenuStyle();

  const currentValueArray =
    currentValue && currentValue !== EMPTY_STRING
      ? currentValue.split(',')
      : [];

  const [optionsState, dispatch] = useReducer(
    optionsReducer,
    currentValueArray || []
  );

  const lastSavedValue = useRef(currentValueArray || []);

  // Handle input change
  const handleDaysOptionsChange = event => {
    const selectedValue = event.target.value;
    const inOptions = !!optionsState.find(value => value === selectedValue);

    if (inOptions) {
      dispatch({ type: 'remove', payload: { value: selectedValue } });
    } else {
      dispatch({ type: 'add', payload: { value: selectedValue } });
    }
  };

  // Call onSave only after currentValue updates
  useEffect(() => {
    if (optionsState !== lastSavedValue.current) {
      const filtersValue =
        optionsState.length === 0
          ? dayOptions.map(day => day.value).join(',') // all days
          : optionsState.sort().join(',');

      onSave({
        WeekDays: filtersValue,
        RawWeekDays: optionsState, // raw user selection
      });
      lastSavedValue.current = optionsState;
    }
  }, [optionsState, onSave]);

  // for clear filter Sync local state with prop changes
  useEffect(() => {
    const newValueArray =
      currentValue && currentValue !== EMPTY_STRING
        ? currentValue.split(',')
        : [];

    dispatch({ type: 'reset', payload: { value: newValueArray } });
  }, [currentValue]);

  return (
    <Fragment>
      <div css={filterMenuStyles.filterHead}>
        <h5 css={filterMenuStyles.filterTitle}>
          Days
          <span>
            <TooltipInfo icon={<ToolTipIcon />} headTitle="Days">
              <>
                <div>
                  For Team football, the day is when matches are played. Team
                  training may be delivered on different days.
                </div>
                <div>
                  For Sessional football, the day is when the session is
                  running.
                </div>
              </>
            </TooltipInfo>
          </span>
        </h5>
      </div>
      <div css={filterMenuStyles.filterBody}>
        <ul css={styles.listWrapper}>
          {dayOptions &&
            dayOptions.map(({ id, text, value: optionValue }) => {
              const isChecked = optionsState.includes(optionValue);

              return (
                <li key={optionValue}>
                  <label
                    htmlFor={`option-${id}`}
                    css={styles.chooseFilter(isChecked)}
                    key={optionValue}
                  >
                    <span>{text}</span>

                    <input
                      type="checkbox"
                      id={`option-${id}`}
                      name={`option-${id}`}
                      checked={isChecked}
                      value={optionValue}
                      css={styles.optionCheckbox}
                      onChange={handleDaysOptionsChange}
                      tabIndex={filterShowHide ? 0 : -1}
                    />
                    <span />
                  </label>
                </li>
              );
            })}
        </ul>
      </div>
    </Fragment>
  );
};

FilterByDays.propTypes = {
  currentValue: PropTypes.string,
  onSave: PropTypes.func,
};

export default FilterByDays;
